export const toggleButtonLoadStatus = (
  button: HTMLElement,
  status: boolean,
) => {
  const method = status ? "add" : "remove";
  const btnBorderWidth = 2; // Width is 1px but border increase with of button x2
  if (button) {
    button.style.width = `${button.clientWidth + btnBorderWidth}px`;
    button.style.height = `${button.clientHeight + btnBorderWidth}px`;
    button.classList[method]("loading");
  }
};

export const handleContentLoader = (
  selector: HTMLDivElement,
  status: boolean,
  error_msg = "",
) => {
  let method = status ? "add" : "remove";
  if (error_msg) {
    method = "remove";
    selector.classList.add("is_error");
    const error = selector.querySelector(".content-error .message");
    if (error) {
      // @ts-ignore
      error.innerHTML = error_msg;
    }
  }
  selector.classList.remove("is_error");
  selector.classList[method]("loading");
};

export function updateTableItemsOrder(tableBodyElement, selector) {
  if (tableBodyElement) {
    const elements = tableBodyElement.querySelectorAll("tr");
    if (elements) {
      elements.forEach((element: HTMLDivElement, i: number) => {
        const indexElement = element.querySelector(selector);
        if (indexElement) {
          indexElement.innerHTML = String(i + 1);
        }
      });
    }
  }
}

export function new_el(tag, attrs) {
  const e = document.createElement(tag);
  if (attrs !== undefined)
    Object.keys(attrs).forEach((k) => {
      if (k === "class") {
        Array.isArray(attrs[k])
          ? attrs[k].forEach((o) => (o !== "" ? e.classList.add(o) : 0))
          : attrs[k] !== ""
          ? e.classList.add(attrs[k])
          : 0;
      } else if (k === "style") {
        Object.keys(attrs[k]).forEach((ks) => {
          e.style[ks] = attrs[k][ks];
        });
      } else if (k === "text") {
        attrs[k] === "" ? (e.innerHTML = "&nbsp;") : (e.innerText = attrs[k]);
      } else e[k] = attrs[k];
    });
  return e;
}

export function hmsToSecondsOnly(str) {
  // eslint-disable-next-line prefer-const
  let p = str.split(":"),
    s = 0,
    m = 1;

  while (p.length > 0) {
    s += m * parseInt(p.pop(), 10);
    m *= 60;
  }

  return s;
}

function dec2hex(i) {
  return (i + 0x10000).toString(16).substr(-4).toUpperCase();
}

export const generateCryptoString = (len?: number) => {
  const arr = new Uint8Array((len || 40) / 2);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, dec2hex).join("");
};

export const convert_bytes_ty_mb = (size: number) =>
  (size / (1024 * 1024)).toFixed(2);

export function getCookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}
type CookieOptions = {
  expires?: string | Date;
  secure?: boolean;
  "max-age"?: boolean;
  path?: string;
  domain?: string;
};
export function setCookie(
  name: string,
  value: string,
  options: CookieOptions = {},
) {
  options = {
    path: "/",
    ...options,
  };
  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }
  let updatedCookie =
    encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (const optionKey in options) {
    updatedCookie += "; " + optionKey;
    const optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }
  console.log(updatedCookie);
  document.cookie = updatedCookie;
}
